import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { ReactNode } from "react";
import { FilterActions, FilterBarWrap, FilterControls } from "./style";
import { useTranslation } from "react-i18next";

export interface ListFilterBarActions {
  /** 触发搜索，可直接绑定到关键字输入框的 onPressEnter */
  submit: () => void;
}

export interface ListFilterBarProps {
  /** 支持普通节点，也支持通过 render-prop 获取 submit */
  children:
    | ReactNode
    | ((actions: ListFilterBarActions) => ReactNode);
  /** 提交当前筛选条件 */
  onSearch: () => void;
  /** 清空筛选条件 */
  onReset: () => void;
  /** 查询期间禁用搜索和清空 */
  disabled?: boolean;
  /** 是否显示清空按钮，默认显示 */
  showReset?: boolean;
}

/**
 * 统一列表筛选区的布局和操作入口。
 * 组件不管理业务字段，搜索与清空逻辑由父组件提供。
 */
const ListFilterBar = ({
  children,
  onSearch,
  onReset,
  disabled = false,
  showReset = true,
}: ListFilterBarProps) => {
  const { t } = useTranslation();
  const submit = () => {
    if (!disabled) onSearch();
  };

  const controls =
    typeof children === "function" ? children({ submit }) : children;

  return (
    <FilterBarWrap>
      <FilterControls>{controls}</FilterControls>
      <FilterActions>
        <Tooltip title={t("purchase.search")}>
          <Button
            type="primary"
            htmlType="button"
            icon={<SearchOutlined />}
            aria-label={t("purchase.search")}
            disabled={disabled}
            onClick={submit}
          />
        </Tooltip>
        {showReset && (
          <Tooltip title={t("purchase.clearFilters")}>
            <Button
              type="primary"
              htmlType="button"
              icon={<DeleteOutlined />}
              aria-label={t("purchase.clearFilters")}
              disabled={disabled}
              onClick={onReset}
            />
          </Tooltip>
        )}
      </FilterActions>
    </FilterBarWrap>
  );
};

export default ListFilterBar;
